
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/swiper-bundle.min.css';

const module = {
	init: function (elm, options, control) {
		// Validate that elm is a valid DOM Element
		if (!elm || !(elm instanceof Element)) {
			console.warn('TeraSwiper: Invalid element provided');
			return null;
		}

		// Check if element already has a swiper instance
		if (elm.swiper) {
			console.warn('TeraSwiper: Swiper already initialized on this element');
			return elm.swiper;
		}

		const initializeSwiper = () => {
			Swiper.use([Navigation, Pagination, Autoplay]);

			options.observer = true;
			options.observeParents = true;
			options.updateOnImagesReady = true;

			const slideCount = elm.querySelectorAll('.swiper-slide').length;

			// Don't initialize if no slides
			if (slideCount === 0) {
				console.warn('TeraSwiper: No slides found, skipping initialization');
				return null;
			}

			const swiper = new Swiper(elm, options);

			// Helper to get current slidesPerView from Swiper instance
			function getCurrentSlidesPerView() {
				return typeof swiper.params.slidesPerView === 'function'
					? swiper.params.slidesPerView()
					: swiper.params.slidesPerView;
			}

			function updateControlsVisibility() {
				const currentSlidesPerView = getCurrentSlidesPerView();
				// If both are 1, do nothing (ignore)
				if (currentSlidesPerView === 1 && slideCount === 1) {
					return;
				}

				if (slideCount <= currentSlidesPerView && control) {
					control.style.display = 'none';
				}
			}

			// Initial check
			updateControlsVisibility();

			// Listen for breakpoint changes to update controls visibility
			swiper.on('breakpoint', updateControlsVisibility);

			// Return swiper instance for external control
			return swiper;
		};

		// Check if document is already loaded
		if (document.readyState === 'complete' || document.readyState === 'interactive') {
			return initializeSwiper();
		} else {
			// Wait for document to be fully loaded
			document.addEventListener('DOMContentLoaded', () => {
				initializeSwiper();
			});
			return null;
		}
	}
}

export { module as TeraSwiper }